export const minigridTypes = {
    IS_LOADING_LIST_MINIGRID: 'IS_LOADING_LIST_MINIGRID',
    SET_QUERY_SEARCH: 'SET_QUERY_SEARCH'
}